"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var utils_1 = require("../utils/utils");
var therapist = {};
function init() {
    var profile_form = (0, utils_1.get_element_by_id_or_null)('profile-form', HTMLFormElement);
    if (!profile_form)
        return;
    var edit_button = (0, utils_1.get_element_by_id_or_fail)('profile-form-edit-button', HTMLButtonElement);
    var cancel_button = (0, utils_1.get_element_by_id_or_fail)('profile-form-cancel-button', HTMLButtonElement);
    var save_button = (0, utils_1.get_element_by_id_or_fail)('profile-form-save-button', HTMLButtonElement);
    var form_buttons = {
        edit_button: edit_button,
        cancel_button: cancel_button,
        save_button: save_button,
    };
    edit_button.addEventListener('click', function () {
        activate_edit_mode(profile_form, form_buttons);
        enable_all_input_fields_template_func(profile_form);
    });
    cancel_button.addEventListener('click', function () {
        deactivate_edit_mode(profile_form, form_buttons);
        disable_all_input_fields_template_func(profile_form);
    });
    save_button.addEventListener('click', function () {
        // deactivate_edit_mode(form_buttons);
    });
}
exports.init = init;
function activate_edit_mode(form, buttons) {
    form.classList.remove('js-disabled');
    form.classList.add('js-edit');
    buttons.edit_button.classList.add('hidden');
    buttons.cancel_button.classList.remove('hidden');
    buttons.save_button.classList.remove('hidden');
}
function deactivate_edit_mode(form, buttons) {
    form.classList.add('js-disabled');
    form.classList.remove('js-edit');
    buttons.edit_button.classList.remove('hidden');
    buttons.cancel_button.classList.add('hidden');
    buttons.save_button.classList.add('hidden');
}
function send_form_template_func(profile_form) {
    return function () {
        for (var i = 0; i < profile_form.elements.length; ++i) {
            var input = profile_form.elements.item(i);
            if (!(input instanceof HTMLInputElement))
                continue;
            input.disabled = false;
        }
    };
}
function enable_all_input_fields_template_func(profile_form) {
    for (var i = 0; i < profile_form.elements.length; ++i) {
        var input = profile_form.elements.item(i);
        if (!(input instanceof HTMLInputElement))
            continue;
        input.disabled = false;
    }
}
function disable_all_input_fields_template_func(profile_form) {
    for (var i = 0; i < profile_form.elements.length; ++i) {
        var input = profile_form.elements.item(i);
        if (!(input instanceof HTMLInputElement))
            continue;
        input.disabled = true;
    }
}
